// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.validator_metrics_container {
    border: 1px solid black;
    padding: 20px;
    margin: auto;
    background-color: var(--card-background-color);
}

/* Content wrapper */
.metrics_content {
    width: 100%;
}

/* Center container */
.metrics_center_container {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Header section */
.validator_metrics_header {
    text-align: center;
    padding: 15px;
    border-radius: 6px;
    background-color: var(--background-color);
}

.validator_metrics_header h3 {
    color: var(--text-color);
    font-size: 18px;
    margin: 0 0 16px 0;
    font-weight: normal;
    font-family: var(--app-font-family);
}

.block_height_value {
    color: var(--primary-color);
    font-size: 24px;
    font-weight: bold;
    font-family: var(--app-font-family);
}

/* Chart container */
.recharts-responsive-container {
    margin: 20px 0;
}

/* Footer section */
.validator_metrics_footer {
    text-align: center;
    padding: 15px;
    border-radius: 6px;
    background-color: var(--background-color);
}

.total_validators {
    color: var(--text-color);
    font-size: 16px;
    font-family: var(--app-font-family);
}

/* Media queries */
@media screen and (max-width: 768px) {
    .validator_metrics_container {
        padding: 15px;
    }

    .metrics_center_container {
        max-width: 100%;
    }

    .block_height_value {
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/hype_staking/totalValidatorMetricsPieChart.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,8CAA8C;AAClD;;AAEA,oBAAoB;AACpB;IACI,WAAW;AACf;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA,oBAAoB;AACpB;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,mCAAmC;AACvC;;AAEA,kBAAkB;AAClB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Main container */\n.validator_metrics_container {\n    border: 1px solid black;\n    padding: 20px;\n    margin: auto;\n    background-color: var(--card-background-color);\n}\n\n/* Content wrapper */\n.metrics_content {\n    width: 100%;\n}\n\n/* Center container */\n.metrics_center_container {\n    width: 100%;\n    max-width: 420px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n/* Header section */\n.validator_metrics_header {\n    text-align: center;\n    padding: 15px;\n    border-radius: 6px;\n    background-color: var(--background-color);\n}\n\n.validator_metrics_header h3 {\n    color: var(--text-color);\n    font-size: 18px;\n    margin: 0 0 16px 0;\n    font-weight: normal;\n    font-family: var(--app-font-family);\n}\n\n.block_height_value {\n    color: var(--primary-color);\n    font-size: 24px;\n    font-weight: bold;\n    font-family: var(--app-font-family);\n}\n\n/* Chart container */\n.recharts-responsive-container {\n    margin: 20px 0;\n}\n\n/* Footer section */\n.validator_metrics_footer {\n    text-align: center;\n    padding: 15px;\n    border-radius: 6px;\n    background-color: var(--background-color);\n}\n\n.total_validators {\n    color: var(--text-color);\n    font-size: 16px;\n    font-family: var(--app-font-family);\n}\n\n/* Media queries */\n@media screen and (max-width: 768px) {\n    .validator_metrics_container {\n        padding: 15px;\n    }\n\n    .metrics_center_container {\n        max-width: 100%;\n    }\n\n    .block_height_value {\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
